import * as yup from 'yup';

import i18n from '../../../../i18n/configs';

const emailValidation = yup
  .string()
  .lowercase()
  .required(i18n.t('validation.error.required'))
  .email(i18n.t('validation.error.email'))
  .matches(
    /^(?!.*(^[\w.+]+(@gmail\.com|@yahoo\.co\.jp|@aol\.jp|@icloud\.com|@outlook\.jp|@outlook\.com|@hotmail\.com|@live\.jp|@docomo\.ne\.jp|@ezweb\.ne\.jp|@softbank\.ne\.jp|@[\w.+]+.vodafone\.ne\.jp)$)).+$/,
    i18n.t('validation.error.specificEmail')
  );

const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

const phoneValidation = yup.string().matches(phoneRegExp, {
  excludeEmptyString: true,
  message: i18n.t('validation.error.phone')
});

const requiredValidation = yup
  .string()
  .required(i18n.t('validation.error.required'));

export const contactSchema = yup.object().shape({
  category: yup
    .number()
    .required()
    .oneOf([1, 2, 3, 4], i18n.t('validation.error.required')),
  companyName: requiredValidation.max(250, i18n.t('validation.error.below250')),
  email: emailValidation,
  issue: yup.number().required(i18n.t('validation.error.required')),
  message: requiredValidation.max(1000, i18n.t('validation.error.below1000')),
  phone: phoneValidation
});

export const wholeContactSchema = yup.object().shape({
  category: yup
    .number()
    .required()
    .oneOf(
      [1, 2, 3, 10, 11, 12, 13, 14, 15, 31, 32, 99],
      i18n.t('validation.error.required')
    ),
  companyName: requiredValidation.max(250, i18n.t('validation.error.below250')),
  email: emailValidation,
  message: requiredValidation.max(1000, i18n.t('validation.error.below1000')),
  phone: phoneValidation
});
